import { DOCUMENT } from '@angular/common';
import { Component, Inject, OnInit } from '@angular/core';

@Component({
  selector: 'app-accommodations',
  templateUrl: './accommodations.component.html',
  styleUrls: ['./accommodations.component.sass']
})
export class AccommodationsComponent implements OnInit {
  loadAPI: Promise<any>;

  constructor(@Inject(DOCUMENT) private document: Document) {        
    this.loadAPI = new Promise((resolve) => {
        this.loadScript();
        resolve(true);
    });
}

  ngOnInit(): void {
  }

  public loadScript() {        
    var isFound = false;
    var scripts = this.document.getElementsByTagName("script")
    for (var i = 0; i < scripts.length; ++i) {
        if (scripts[i].getAttribute('src') != null && scripts[i].getAttribute('src').includes("loader")) {
            isFound = true;
        }
    }

    if (!isFound) {
        var dynamicScript = "assets/bookingwidget.js";

        let node = this.document.createElement('script');
        node.src = dynamicScript;
        node.type = 'text/javascript';
        node.async = false;
        node.charset = 'utf-8';
        this.document.getElementsByTagName('head')[0].appendChild(node);
    }
}

}
